import {ChangeDetectionStrategy, Component, DestroyRef, inject} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {finalize} from 'rxjs';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzDescriptionsModule} from 'ng-zorro-antd/descriptions';
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {AuthFlowService} from '../../../core/services/auth-flow.service';
import {BlockUserModalData} from './block-user-modal-data';

@Component({
  selector: 'app-block-user-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzDescriptionsModule,
  ],
  templateUrl: './block-user-modal.html',
  styleUrl: './block-user-modal.css',
})
export class BlockUserModal {
  private readonly translate = inject(TranslateService);
  private readonly _data = inject<BlockUserModalData>(NZ_MODAL_DATA);
  private readonly _modalRef = inject(NzModalRef);
  private readonly _authFlow = inject(AuthFlowService);
  private readonly _notification = inject(NzNotificationService);
  private readonly _destroyRef = inject(DestroyRef);

  readonly username = this._data.username;

  readonly commentControl = new FormControl('', {nonNullable: true});

  handleOk(): void {
    this._modalRef.updateConfig({nzOkLoading: true, nzCancelDisabled: true});

    this._authFlow.blockManagedUser(this._data.userId, this.commentControl.value)
      .pipe(finalize(() => this._modalRef.updateConfig({nzOkLoading: false})), takeUntilDestroyed(this._destroyRef))
      .subscribe({
        next: () => {
          this._modalRef.close(true);
          this._notification.success(this.translate.instant('common.success'), this.translate.instant('adminUsers.userBlocked'));
        },
        error: () => {
          this._modalRef.updateConfig({nzCancelDisabled: false});
        }
      });
  }
}
